import { Component } from '@angular/core';

@Component({
  selector: 'app-preview-section',
  standalone: true,
  templateUrl: './preview-section.component.html',
  styleUrl: './preview-section.component.scss'
})
export class PreviewSectionComponent {
  activeSection = 0;
}

